import * as React from 'react'
import { UpdateActionButton } from '../LessonListActionButton'
import { LessonTypeSummaryCard } from '../LessonTypeSummaryCard'
import { LessonTypeId } from '../LessonListContent'

export const SelectedLessonTypeSummary2 = ({
  selectedLessonTypeId,
  onUnselect,
}: {
  selectedLessonTypeId?: LessonTypeId
  onUnselect: () => void
}) => {
  return (
    <div className="flex justify-center mt-6">
      {selectedLessonTypeId && (
        <LessonTypeSummaryCard
          lessonTypeId={selectedLessonTypeId}
          actionButton={<UpdateActionButton onClick={onUnselect} />}
        />
      )}
    </div>
  )
}
